export default __webpack_public_path__ + "static/media/btn-light-off.ac1a430a.svg";